<template>
  <div
    id="emails"
  >
    <h2>
      Targeted Emails
    </h2>

    <email-nav />

    <pagination
      :resourceUrl="resourceUrl"
      orderBy="created_at"
      orderType="DESC"
      ref="pagination"
      attrIncludes
    >
      <template
        slot="paged_item"
        slot-scope="item"
      >
        <router-link
          :to="{
            name: 'email',
            params: {
              emailId: item.id
            }
          }"
          class="list-group-item list-group-item-action"
        >
          {{ item.display_name }}
            <span
              class="badge badge-secondary"
            >
              {{ item.status }}
            </span>
        </router-link>
      </template>
    </pagination>

  </div>
</template>
<script>
import { mapState } from 'vuex'

import Pagination from 'sai-vue-kaminari'

import EmailNav from '@/components/EmailNav'

export default {
  components: {
    'email-nav': EmailNav,
    'pagination': Pagination
  },

  computed: mapState({
    resourceUrl () {
      return this.apiUrl('/targeted_emails', true)
    },

    emails: state => state.EmailModule.emails
  }),

  created () {
  },

  methods: {
    onPageSuccess () {},

    onPageError (resp) {
      this.$root.processErrors(resp)
    },

    processErrors (resp) {
      this.onPageError(resp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Emails.vue